import { render, staticRenderFns } from "./VerbsPage.vue?vue&type=template&id=26ee7d90"
import script from "./VerbsPage.vue?vue&type=script&lang=js"
export * from "./VerbsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports